// src/SyntraMfgMetaverseLanding.jsx
import React, { useState } from "react";
import SyntraMfgMetaverseHeroSection from "./components/SyntraMfgMetaverseHeroSection";
import SyntraMfgMetaverseStakeholdersGrid from "./components/SyntraMfgMetaverseStakeholdersGrid";
import SyntraMfgMetaverseMarketplace from "./components/SyntraMfgMetaverseMarketplace";
import SyntraMfgMetaverseStagedTimeline from "./components/SyntraMfgMetaverseStagedTimeline";
import SyntraMfgMetaverseAnimatedUniverse from "./components/SyntraMfgMetaverseAnimatedUniverse";
import SyntraMfgMetaverseMap from "./components/SyntraMfgMetaverseMap";

const SyntraMfgMetaverseLanding = () => {
  // Dummy "player"
  const [player] = useState({ id: "player1", name: "You" });

  // Dummy marketplace dataset (replace with real manufacturing listings later)
  const [selectedListings, setSelectedListings] = useState([
    { id: 1, type: "product", name: "Steel Sheets", owner: "player1" },
    { id: 2, type: "product", name: "Cement Bags", owner: "resident1" },
    { id: 3, type: "machine", name: "CNC Machine", owner: "resident2" },
    { id: 4, type: "product", name: "Pharma Tablets", owner: null },
    { id: 5, type: "facility", name: "Assembly Line", owner: "resident3" },
  ]);

  // Example handlers
  const handleContact = (listing) => {
    alert(`Contacting owner of ${listing.name}`);
  };

  const handleMakeOffer = (listing, amount) => {
    alert(`Making offer of ₹${amount} for ${listing.name}`);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-blue-200 px-4 py-6">
      <SyntraMfgMetaverseHeroSection />
      <SyntraMfgMetaverseAnimatedUniverse />

      {/* Marketplace */}
      <SyntraMfgMetaverseMarketplace onSelect={setSelectedListings} />

      {/* Industrial / Manufacturing Map */}
      <SyntraMfgMetaverseMap
        rows={6}
        cols={8}
        dataset={selectedListings}
        ownerId={player.id}
        onContact={handleContact}
        onMakeOffer={handleMakeOffer}
      />

      <SyntraMfgMetaverseStagedTimeline />

      {/* CTA */}
      <div className="text-center mt-12">
        <button className="bg-blue-700 text-white px-6 py-3 rounded-2xl text-lg font-semibold shadow-lg hover:bg-blue-800 transition">
          Join Now
        </button>
      </div>
    </div>
  );
};

export default SyntraMfgMetaverseLanding;
